// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__3dgUo","load3":"Spinner__load3__2Umiw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 113
// module chunks = 3